import { Badge } from '@monksflow/monks-ui';
import { SparklesIcon, UsersIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { AudienceStatusChip } from '@/features/audiences';
import type { AudienceDraftStatus } from '../lib/audienceDrafts';
import { NEW_SEGMENT_CHIP } from './newSegmentChip';

interface SuggestedAudienceBadgeProps {
  status: AudienceDraftStatus;
  saved: boolean;
}

/**
 * Says where an audience stands: already in the Knowledge Hub, newly suggested, or failed.
 * Silent while it is being built, which the card and the section cover between them.
 */
export const SuggestedAudienceBadge = ({ status, saved }: SuggestedAudienceBadgeProps) => {
  const { t } = useTranslation('analysis');

  if (status === 'pending' || status === 'processing') {
    return null;
  }

  if (status === 'failed') {
    return <AudienceStatusChip status="failed" />;
  }

  if (saved) {
    return (
      <Badge size="sm" variant="secondary" roundness="full">
        <UsersIcon size={12} />
        {t('analysisResult.suggestedAudiences.audienceKnowledge')}
      </Badge>
    );
  }

  return (
    <Badge size="sm" roundness="full" className={NEW_SEGMENT_CHIP}>
      <SparklesIcon size={12} />
      {t('analysisResult.suggestedAudiences.newSegment')}
    </Badge>
  );
};
